import { mq } from '../../styles/grid';

import ImageProperties from '../image-properties.json';
/**
 * @type {Theme}
 */
const defaultTheme = {
  id: 'fse',
  name: 'fse',
  logo: 'FRESENIUS_SE',
  meshGradient:
    'linear-gradient(0deg, rgba(0, 41, 103, 0.45) 0%, rgba(0, 41, 103, 0.45) 100%), url(/assets/images/gradient.jpeg) lightgray 0px -2.5px / 100.637% 101.465% no-repeat !important;',
  bookmarkLimit: 25,
  bookmarkName: 'bookmarks-fse',
  hasShareSection: true,
  shareBtns: ['TWITTER', 'FACEBOOK', 'XING', 'LINKEDIN', 'WHATSAPP', 'MAIL'],
  jobSearch: {
    showCompanyColumn: true,
    showMap: true,
    filterGeolocation: '',
  },
  font: {
    light: '"MalloryLight", sans-serif',
    regular: '"MalloryRegular", sans-serif',
    bold: '"MalloryBold", sans-serif',
    black: '"MalloryBold", sans-serif',
  },
  arrowType: 'slim',
  designTokens: {
    spacing: {
      zero: '0',
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '32px',
      xl2: '40px',
      xl3: '48px',
      xl4: '56px',
      xl5: '64px',
      xl6: '72px',
      xl7: '80px',
      xl8: '96px',
      xl9: '120px',
      xl10: '160px',
    },
    spacingNumbers: {
      zero: 0,
      xs: 4,
      sm: 8,
      md: 16,
      lg: 24,
      xl: 32,
      xl2: 40,
      xl3: 48,
      xl4: 56,
      xl5: 64,
      xl6: 72,
      xl7: 80,
      xl8: 96,
      xl9: 120,
      xl10: 160,
    },
    radius: {
      zero: '0',
      xs: '2px',
      sm: '4px',
      md: '8px',
      lg: '12px',
      xl: '16px',
      xl2: '24px',
      pill: '999px',
    },
    breakpoints: {
      xss: '320px',
      xs: '375px',
      sm: '768px',
      md: '1024px',
      lg: '1440px',
      xl: '1920px',
    },
    colors: {
      accentColorRed: {
        accentColorRed100: '#EC6084',
        accentColorRed50: '#F6B8C3',
        accentColorRed25: '#FBDDE3',
      },
      accentColorYellow: {
        accentColorYellow100: '#F1AA00',
        accentColorYellow50: '#FDDAAB',
        accentColorYellow25: '#FFEDD7',
      },
      deepHumanBlue: {
        deepHumanBlue100: '#002967',
        deepHumanBlue80: '#335485',
        deepHumanBlue60: '#667FA4',
        deepHumanBlue30: '#B2C3E5',
        deepHumanBlue20: '#CCD4E1',
        deepHumanBlue10: '#DBE0EE',
      },
      grey: {
        grey100: '#363F44',
        grey80: '#5E6569',
        grey60: '#868C8F',
        grey40: '#AFB2B4',
        grey30: '#C3C5C7',
        grey20: '#D7D9DA',
        grey10: '#EBECEC',
      },
      jade: {
        jade100: '#00967D',
        jade60: '#96D7BE',
        jadeBold: '#195661',
      },
      aquamarine: '#00B2A9',
      azure: '#005AC8',
      black: '#000000',
      coral: '#FF4052',
      lemon: '#FFF14B',
      sky: '#B4D8EF',
      white: '#FFFFFF',
    },
  },
  color: {
    primary800: '#002967',
    primary700: '#1E4279',
    primary600: '#4176C7',
    primary500: '#6880A5',
    secondary800: '#C74190',
    secondary700: '#DD8DBC',
    brandSuccess500: '#1CA642',
    brandDanger500: '#B90739',
    cta: '#002967',
    ctaSecondary: '#ffffff',
    jobTeaserBackground: '#DBE0EE',
    white500: '#ffffff',
    black500: '#000000',
    gray50: '#f4f4f4',
    gray100: '#efefef',
    gray200: '#e8e8e8',
    gray300: '#e1e1e1',
    gray400: '#e7e7e7',
    gray500: '#c1c1c1',
    gray600: '#6b6b6b',
    gray700: '#4f4f4f',
    gray800: '#979797',
    basicFontColor: '#6b6b6b',
    basicHeadlineColor: '#002967',
    gradientprimary500: 'linear-gradient(225deg, #3461A5 0%, #002967 100%)',
    gradientprimary600: '#002967',
    gradientprimary700: 'linear-gradient(270deg, #005AC8 0%, #002A69 100%)',
    gradientgray300: 'linear-gradient(224.61deg, #F4F4F4 0%, #DCDADA 100%)',
    searchHeroGradient:
      'linear-gradient(32deg, rgba(0, 41, 103, 1) 0%, rgba(214, 75, 148, 0.7) 50%,rgba(214, 75, 148, 0.9) 100%)',
    transparent: 'transparent',
    flyoutFontColor: '#002967',
    highlighted: '',
    deepHumanBlue100: '#002967',
    deepHumanBlue60: '#667FA4',
    deepHumanBlue30: '#B2C3E5',
    deepHumanBlue20: '#CCD4E1',
    deepHumanBlue10: '#DBE0EE',
    grey100: '#3F4E54',
    grey60: '#8A98A0',
    grey30: '#C3CCD1',
    grey20: '#D7DDE1',
    grey10: '#EBEEF0',
    accentColorYellow100: '#F1AA00',
    accentColorYellow50: '#FDDAAB',
    accentColorYellow25: '#FFEDD7',
    accentColorRed100: '#EC6084',
    accentColorRed50: '#F6B8C3',
    accentColorRed25: '#FBDDE3',
  },
  spacing: {
    xl: {
      spacing900: '130px',
      spacing850: '90px',
      spacing800: '85px',
      spacing700: '60px',
      spacing600: '40px',
      spacing500: '30px',
      spacing400: '15px',
      spacing300: '-100px',
      spacing0: '0',
    },
    xs: {
      spacing900: '60px',
      spacing850: '60px',
      spacing800: '70px',
      spacing700: '50px',
      spacing600: '30px',
      spacing500: '20px',
      spacing400: '10px',
      spacing300: '0',
      spacing0: '0',
    },
  },
  spacer: {
    color: 'gray500',
  },
  pageHeading: {
    spacingTop: 'spacing500',
  },
  backToTopBtn: {
    icon: 'BACK_TO_TOP',
    offset: 666,
    right: 15,
    bottom: 0,
  },
  dividerColor: 'rgba(255, 255, 255, 0.3)',
  header: {
    bgColor: 'white500',
    divider: 'rgba(0, 0, 0, 0.1)',
    dividerLight: 'rgba(255, 255, 255, 0.3)',
    dividerHorizontal: '1px solid #dbe0ee',
    flyoutBgColor: '#ffffff',
    height: 68,
    heightMobile: 55,
    mobileSwitch: mq.mdDown,
    opacity: 0.9,
    pageContentOverlay: 'rgba(0, 41, 103, 0.70)',
    mainNavigationFooterColor: 'deepHumanBlue100',
    showLogin: true,
    showFavourites: true,
    showFollowUs: true,
    showContentSearch: true,
    showLanguageSwitch: true,
    showCountrySwitch: true,
    showMainNavigation: true,
    fontColor: 'deepHumanBlue100',
    ctaFindJobBgColor: 'deepHumanBlue100',
    ctaFindJobColor: 'white500',
    fontSize: '16px',
    mainNavigation: {
      itemBgColorActive: 'grey10',
    },
    flyout: {
      bgColor: 'deepHumanBlue100',
    },
  },
  benefits: {
    mobileSwitch: mq.smDown,
  },
  breadcrumb: {
    maxSegmentLength: 30,
    mobileSwitch: mq.smDown,
    bgColor: 'linear-gradient(90deg, #002967 0%, rgba(0, 41, 103, 0) 100%)',
  },
  hero: {
    mobileSwitch: mq.mdDown,
    bgImageMaxWidth: {
      xxs: '563px',
      xs: '563px',
      sm: '563px',
      md: '563px',
      lg: '563px',
      xl: '1920px',
      xxl: '1920px',
      default: '1920px',
    },
    bgImageHeight: {
      xxs: '435px',
      xs: '435px',
      sm: '435px',
      md: '435px',
      lg: '435px',
      xl: '420px',
      xxl: '420px',
      default: '420px',
    },
    bgImageHeightNarrowWide: {
      xxs: '824px',
      xs: '824px',
      sm: '614px',
      md: '614px',
      lg: '614px',
      xl: '824px',
      xxl: '824px',
      default: '824px',
    },
    bgImageMinHeightNarrowWide: {
      xxs: '300px',
      xs: '300px',
      sm: '300px',
      md: '300px',
      lg: '300px',
      xl: '250px',
      xxl: '250px',
      default: '824px',
    },
    bgImageMarginTopNarrowWide: {
      xxs: '30vw',
      xs: '65vw',
      sm: '34vw',
      md: '34vw',
      lg: '724px',
      xl: '724px',
      xxl: '34vw',
      default: '370px',
    },
    background: 'meshGradient',
  },
  searchHero: {
    mobileSwitch: mq.smDown,
    bgImgOpacity: 1,
    useGeoLocationBtn: true,
  },
  contentHub: {
    mobileSwitch: mq.smDown,
  },
  teaserFullWidth: {
    ctaStyle: 'PRIMARY',
    fmcStyle: false,
    height: {
      xxs: '350px',
      xs: '550px',
      sm: '580px',
      md: '350px',
      lg: '350px',
      xl: '350px',
      xxl: '350px',
      default: '350px',
    },
  },
  highlightHero: {
    type: 'HERO_STAGE_SINGLE_HIGHLIGHT',
    mobileSwitch: mq.smDown,
    headline: {
      fontSize: { xl: '112px', md: '65px', xs: '50px' },
      lineHeight: { xl: '50px', md: '35px', xs: '28px' },
      letterSpacing: { xl: '-3px' },
    },
    subHeadline: {
      fontSize: { xl: '40px', xs: '23px' },
    },
  },
  jobDetail: {
    logo: true,
    mobileSwitch: mq.mdDown,
    titleFontSize: 20,
    applicationStarted: {
      ContactMarginTopDefault: 38,
      ContactMarginTopMobile: 37,
      WrapperPaddingTopMobile: 2.5,
    },
    automaticTranslation: false,
  },
  cmsTabs: {
    mobileSwitch: mq.mdDown,
  },
  footer: {
    icon: 'HEART',
    mobileSwitch: mq.mdDown,
    hoverColor: 'cta',
    linksMargin: 40,
    fontSize: '18px',
    linksInGrid: false,
    genderNotice: false,
    showBigFooter: true,
    logoFooter: 'FRESENIUS_SE',
    fontColor: 'white500',
  },
  slider: {
    mobileSwitch: mq.smDown,
  },
  eventCounter: {
    mobileSwitch: mq.lgDown,
  },
  teaserCareer: {
    mobileSwitch: mq.smDown,
  },
  socialStream: {
    mobileSwitch: mq.xs,
  },
  jobSearchResult: {
    mobileSwitch: mq.lg,
  },
  jobTeaser: {
    mobileSwitch: mq.smDown,
  },
  jobAlert: {
    mobileSwitch: mq.smDown,
  },
  searchFlags: {
    mobileSwitch: mq.smDown,
  },
  displayToggleWrapper: {
    mobileSwitch: mq.smDown,
  },
  table: {
    mobileSwitch: mq.smDown,
    headerBgColor: 'gray500',
    brightCellBgColor: 'gray50',
    darkCellBgColor: 'gray200',
    fontColor: 'gray600',
    headerFont: 'regular',
    headerFontColor: 'primary800',
    cellFont: 'regular',
    xl: {
      fontSize: '16px',
      headerFontSize: '18px',
    },
    xs: {
      fontSize: '16px',
      headerFontSize: '16px',
    },
  },
  forms: {
    fontSize: '16px',
    lineHeight: '1.44',
    fontSizeLabelFocused: '14px',
    borderBottomWidth: '1px',
    borderBottomDefault: 'gray600',
    borderBottomHover: 'cta',
  },
  cta: {
    primaryBgColor: 'deepHumanBlue100',
    primaryBgHoverColor: 'deepHumanBlue30',
    primaryFontColor: 'white500',
    primaryFontFamily: 'regular',
    primaryFontSize: '18px',
    primaryFontSizeMd: '16px',
    primaryHoverFontColor: 'deepHumanBlue100',
    primaryLineHeight: '120%',
    primaryPaddingX: 24,
    primaryPaddingXMd: 16,
    primaryPaddingY: 13,
    primaryPaddingYLg: 21,
    primaryPaddingYMd: 10,
    secondaryBgColor: 'white500',
    secondaryBgHoverColor: 'deepHumanBlue30',
    secondaryBorderColor: '2px solid #002967',
    secondaryFontColor: 'deepHumanBlue100',
    secondaryFontFamily: 'regular',
    secondaryFontSize: '18px',
    secondaryLineHeight: '120%',
    tertiaryBgHoverColor: 'deepHumanBlue100',
    tertiaryFontColor: 'deepHumanBlue100',
    tertiaryFontFamily: 'bold',
    tertiaryFontSize: '18px',
    tertiaryLineHeight: '150%',
    brand: {
      primaryBgColor: 'accentColorYellow100',
      primaryBgHoverColor: 'accentColorYellow50',
      primaryBorder: '2px solid #FDDAAB',
      primaryFontColor: 'deepHumanBlue100',
      secondaryBgHoverColor: 'accentColorYellow50',
      secondaryBorder: '2px solid #FDDAAB',
      tertiaryFontColor: 'white500',
      tertiaryBgHoverColor: 'white500',
    },
  },
  copytext: {
    copyBig: {
      fontSize: '18px',
      fontSizeXs: '16px',
      lineHeight: '150%',
      lineHeightXs: '150%',
      textColor: 'primary800',
    },
    copyStandard: {
      fontSize: '18px',
      fontSizeXs: '16px',
      lineHeight: '150%',
      lineHeightXs: '150%',
      textColor: 'gray600',
    },
    copyFineprint: {
      fontSize: '14px',
      fontSizeXs: '14px',
      lineHeight: '1.71',
      lineHeightXs: '1.71',
      textColor: 'gray600',
    },
  },
  editButton: {
    backgroundColor: 'secondary700',
    textColor: 'white500',
    fontSize: '14px',
    icon: 'PENCIL',
    exceptionList: ['CONTAINER_TABS', 'ANCHOR'],
  },
  headline: {
    h800: {
      xl: {
        fontSize: '56px',
        lineHeight: '120%',
      },
      xs: {
        fontSize: '30px',
        lineHeight: '120%',
      },
    },
    h700: {
      xl: {
        fontSize: '40px',
        lineHeight: '120%',
      },
      xs: {
        fontSize: '23px',
        lineHeight: '120%',
      },
    },
    h600: {
      xl: {
        fontSize: '30px',
        lineHeight: '120%',
      },
      xs: {
        fontSize: '23px',
        lineHeight: '120%',
      },
    },
    h500: {
      xl: {
        fontSize: '23px',
        lineHeight: '120%',
      },
      xs: {
        fontSize: '18px',
        lineHeight: '120%',
      },
    },
    h400: {
      xl: {
        fontSize: '18px',
        lineHeight: '120%',
      },
      xs: {
        fontSize: '16px',
        lineHeight: '120%',
      },
    },
  },
  skinMap: {
    heading: {
      h1: 'Headline800',
      h2: 'Headline700',
      h3: 'Headline600',
      h4: 'Headline500',
      h5: 'Headline400',
      h6: 'Headline400',
    },
  },
  spacingMap: {
    login: {
      form: 'spacing400',
    },
    jobSearch: {
      hero: 'spacing300',
      results: 'spacing0',
    },
    jobDetail: {
      hero: 'spacing300',
      heroApplicationStarted: 'spacing0',
      details: 'spacing0',
      overview: 'spacing600',
      contact: 'spacing0',
      contactApplicationStarted: 'spacing900',
      shareBtns: 'spacing0',
      recommendations: 'spacing0',
    },
    contentSearch: {
      headline: 'spacing0',
      intro: 'spacing600',
      searchInputs: 'spacing700',
      searchResults: 'spacing700',
      searchResultsMobile: 'spacing600',
      recommendations: 'spacing0',
    },
    regularPage: {
      shareBtns: 'spacing600',
      footer: 'spacing600',
    },
    landingPage: {
      shareBtns: 'spacing600',
      footer: 'spacing600',
    },
    containerLarge: {
      padding: 'spacing850',
      negative: 'spacing300',
    },
    richtext: {
      li: 'spacing400',
    },
    img: {
      text: 'spacing400',
    },
    cmsDefault: 'spacing600',
    cmsSeparator: 'spacing0',
    guidedSearch: {
      resultsRadio: 'spacing0',
      resultsDropdown: 'spacing600',
      questions: 'spacing600',
      question: 'spacing500',
    },
    cms: {
      HERO_STAGE: {
        CONTAINER_LARGE_A: 'spacing0',
        CONTAINER_LARGE_B: 'spacing0',
        CONTAINER_LARGE_C: 'spacing0',
        ANCHOR: 'spacing0',
      },
      CONTAINER_LARGE_A: {
        CONTAINER_LARGE_A: 'spacing0',
        CONTAINER_LARGE_B: 'spacing0',
        CONTAINER_LARGE_C: 'spacing0',
        QUOTE: 'spacing0',
        ANCHOR: 'spacing0',
        TEXT: 'spacing600',
      },
      CONTAINER_LARGE_B: {
        CONTAINER_LARGE_A: 'spacing0',
        CONTAINER_LARGE_B: 'spacing0',
        CONTAINER_LARGE_C: 'spacing0',
        QUOTE: 'spacing0',
        ANCHOR: 'spacing0',
        TEXT: 'spacing600',
      },
      CONTAINER_LARGE_C: {
        CONTAINER_LARGE_A: 'spacing0',
        CONTAINER_LARGE_B: 'spacing0',
        CONTAINER_LARGE_C: 'spacing0',
        QUOTE: 'spacing0',
        ANCHOR: 'spacing0',
        TEXT: 'spacing600',
      },
      HEADING: {
        TEXT: 'spacing600',
        GUIDED_SEARCH: 'spacing600',
        CTA: 'spacing600',
        VIDEO: 'spacing700',
        IMAGE: 'spacing700',
        LINK_LIST: 'spacing600',
        CAROUSEL: 'spacing600',
        CONTAINER_TEASER_RICH_TEXT: 'spacing600',
        CONTENT_HUB_TEASER: 'spacing600',
      },
      IMAGE: {
        TEXT: 'spacing600',
        IMAGE: 'spacing700',
        HEADING: 'spacing800',
      },
      LINK_LIST: {
        HEADING: 'spacing800',
      },
      CTA: {
        HEADING: 'spacing800',
      },
      GUIDED_SEARCH: {
        HEADING: 'spacing600',
        CTA: 'spacing600',
      },
      HEADING_H1: {
        CONTAINER_LARGE_A: 'spacing500',
        CONTAINER_LARGE_B: 'spacing500',
        CONTAINER_LARGE_C: 'spacing500',
        TEXT: 'spacing0',
      },
      QUOTE: {
        CONTAINER_LARGE_A: 'spacing0',
      },
      TEXT: {
        ANCHOR: 'spacing0',
        CAROUSEL: 'spacing0',
        CONTAINER_LARGE_A: 'spacing0',
        CONTAINER_LARGE_B: 'spacing0',
        CONTAINER_LARGE_C: 'spacing0',
        CONTAINER_TEASER_RICH_TEXT: 'spacing0',
        CTA: 'spacing600',
        GUIDED_SEARCH: 'spacing0',
        HEADING: 'spacing0',
        IMAGE: 'spacing600',
        LINK_LIST: 'spacing0',
        QUOTE: 'spacing600',
        TEXT: 'spacing600',
        VIDEO: 'spacing600',
      },
    },
    globals: {
      h1: {
        h2: 'spacing700',
        h3: 'spacing700',
        h4: 'spacing700',
        h5: 'spacing700',
        h6: 'spacing700',
        p: 'spacing700',
        ul: 'spacing700',
        ol: 'spacing700',
        img: 'spacing700',
        span: 'spacing700',
        small: 'spacing700',
      },
      h2: {
        h3: 'spacing600',
        h4: 'spacing600',
        h5: 'spacing600',
        h6: 'spacing600',
        p: 'spacing600',
        ul: 'spacing600',
        ol: 'spacing600',
        img: 'spacing600',
        span: 'spacing600',
        small: 'spacing600',
      },
      h3: {
        h4: 'spacing500',
        h5: 'spacing500',
        h6: 'spacing500',
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing500',
      },
      h4: {
        h5: 'spacing500',
        h6: 'spacing500',
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing500',
      },
      h5: {
        h6: 'spacing500',
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing500',
      },
      h6: {
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing500',
      },
      p: {
        h2: 'spacing800',
        h3: 'spacing800',
        h4: 'spacing800',
        h5: 'spacing800',
        h6: 'spacing800',
        p: 'spacing500',
        ul: 'spacing400',
        ol: 'spacing400',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing700',
      },
      ul: {
        h2: 'spacing800',
        h3: 'spacing800',
        h4: 'spacing800',
        h5: 'spacing800',
        h6: 'spacing800',
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing700',
      },
      ol: {
        h2: 'spacing800',
        h3: 'spacing800',
        h4: 'spacing800',
        h5: 'spacing800',
        h6: 'spacing800',
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing700',
      },
      span: {
        h2: 'spacing800',
        h3: 'spacing800',
        h4: 'spacing800',
        h5: 'spacing800',
        h6: 'spacing800',
        p: 'spacing500',
        ul: 'spacing500',
        ol: 'spacing500',
        img: 'spacing500',
        span: 'spacing500',
        small: 'spacing700',
      },
      small: {
        h2: 'spacing800',
        h3: 'spacing800',
        h4: 'spacing800',
        h5: 'spacing800',
        h6: 'spacing800',
        p: 'spacing700',
        ul: 'spacing700',
        ol: 'spacing700',
        img: 'spacing700',
        span: 'spacing700',
        small: 'spacing500',
      },
    },
  },
  openGraphImg: ImageProperties['1200x627_og'],
  imgPropertiesMapFn(isSafari = false) {
    const source = isSafari ? 'source_' : '';
    return {
      hero: {
        xxl: ImageProperties[`${source}2880x630_3:1_xl`],
        xl: ImageProperties[`${source}1800_630`],
        lg: ImageProperties[`${source}1536x630_3:1_lg`],
        md: ImageProperties[`${source}1152x518_3:1_md`],
        xs: ImageProperties[`${source}563x435_4:3_xs`],
      },
      wide: {
        xxl: ImageProperties[`${source}1920x824_21:9_xl`],
        xl: ImageProperties[`${source}1440x616_21:9_xl`],
        lg: ImageProperties[`${source}1024x438_21:9_lg`],
        md: ImageProperties[`${source}768x330_21:9_md`],
        xs: ImageProperties[`${source}563x435_4:3_xs`],
      },
      image: {
        xl: ImageProperties[`${source}1226x690_16:9_xl`],
        md: ImageProperties[`${source}1226x690_16:9_xl`],
        xs: ImageProperties[`${source}864x486_16:9_xs`],
      },
      carousel: {
        xl: ImageProperties[`${source}1226x690_16:9_xl`],
        md: ImageProperties[`${source}1226x690_16:9_xl`],
        xs: ImageProperties[`${source}864x486_16:9_xs`],
      },
      quote: {
        xl: ImageProperties[`${source}495x495_1:1_all`],
        md: ImageProperties[`${source}495x495_1:1_all`],
        xs: ImageProperties[`${source}495x495_1:1_all`],
      },
      contentHubTeaser: {
        xl: ImageProperties[`${source}1226x690_16:9_xl`],
        md: ImageProperties[`${source}900x600_3:2_xl`],
        xs: ImageProperties[`${source}864x576_3:2_xs`],
      },
      facts: {
        xl: ImageProperties[`${source}900x600_3:2_xl`],
        md: ImageProperties[`${source}927x636_3:2_md`],
        xs: ImageProperties[`${source}864x576_3:2_xs`],
      },
      teaserTile: {
        xl: ImageProperties[`${source}708x345_16:9_xl`],
        md: ImageProperties[`${source}459x248_16:9_md`],
        xs: ImageProperties[`${source}864x486_16:9_xs`],
      },
    };
  },
};

export default defaultTheme;
